import ClientSelectComponent from './client-select-component'

/***
 * A page that prompts a user to select one or more clients. Once they are selected, the user can view a facility
 * reporting grid for the given clients.
 */
const clientSelect = angular
    .module('FacilityData.FacilityReporting.ClientSelect', [])
    .component('facilityReportingClientSelect', ClientSelectComponent)
    .config(($stateProvider) => {
        'ngInject';
        $stateProvider
            .state('app.facility-reporting.client-select', {
                url: '/facility-reporting/',
                component: 'facilityReportingClientSelect',
                resolve: {
                    clientList: (CommonRequest) => CommonRequest.getClients({has_user_permissions: 1})
                }
            });
    })
    .name;

export default clientSelect;


// WEBPACK FOOTER //
// ./app/components/facility-reporting/client-select/client-select.js